import type { InsightsUpdatedTimestamp, VisitedEvents } from '@pff-consumer/schema'

export function isInsightUpdated({
  updatedTimestamps,
  visitedEventsTimestamp,
  eventId,
}: {
  updatedTimestamps: InsightsUpdatedTimestamp[]
  visitedEventsTimestamp: VisitedEvents
  eventId: number
}) {
  const updatedTimestamp = updatedTimestamps.find((x) => x.eventId === eventId)?.lastUpdated
  const visitedTimestamp = visitedEventsTimestamp[eventId]
  if (!updatedTimestamp || !visitedTimestamp) {
    return false
  }
  return updatedTimestamp > visitedTimestamp
}
